"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.axeCoreUtils = void 0;
var axeConfig_1 = require("./axeConfig");
var axeRun_1 = require("./axeRun");
var axeCoreUtils = function (axeConfig) {
    if (axeConfig === void 0) { axeConfig = axeConfig_1.axeDefaultConfig; }
    var axeUtils = {};
    var testRender = function (variantName, handleRenderComponent) {
        test("Accessibility test for ".concat(variantName), function () {
            var container = handleRenderComponent().container;
            return (0, axeRun_1.axeRun)(container, axeConfig).then(function (results) {
                expect(container.firstChild).toBeTruthy();
                expect(results).toBeNull();
            });
        });
    };
    axeUtils.runTests = function (variantName, handleRenderComponent) {
        testRender(variantName, handleRenderComponent);
        return axeUtils;
    };
    axeUtils.disableRules = function (rulesIds) {
        rulesIds.forEach(function (id) {
            var _a;
            axeConfig = __assign(__assign({}, axeConfig), { rules: __assign(__assign({}, axeConfig.rules), (_a = {}, _a[id] = { enabled: false }, _a)) });
        });
        axeUtils.config = axeConfig;
        return axeUtils;
    };
    axeUtils.config = axeConfig;
    return axeUtils;
};
exports.axeCoreUtils = axeCoreUtils;
